import React from 'react';
import classNames from 'classnames';
import {QuestionGroupViewPropTypes} from "@ignitesales/neuro-application/src/shapes/index";

const CalculatedGroup = (props) => {
  const {
    renderChildren,
    className
  } = props;

  const classes = classNames(
    className,
    'questionGroup--calculatedGroup',
    'calculatedGroup'
  );

  return (
    <section className={ classes }>
      { renderChildren() }
    </section>
  );
};

CalculatedGroup.propTypes = QuestionGroupViewPropTypes;

export default CalculatedGroup;
